import { ref } from 'vue';

export function useModal(initial) {
    const isOpen = ref(initial);
    function dismiss() {
        isOpen.value = false;
    }
    function toggle() {
        isOpen.value = !isOpen.value;
    }
    return {
        isOpen,
        dismiss,
        toggle,
    };
}
